import { render, staticRenderFns } from "./UiLoader.vue?vue&type=template&id=76961ded&scoped=true"
import script from "./UiLoader.vue?vue&type=script&lang=js"
export * from "./UiLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76961ded",
  null
  
)

export default component.exports